(() => {
  if (customElements.get('bestsellers-carousel')) return;

  class BestsellersCarousel extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onNavClick = this.onNavClick.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector('[data-slider]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.nav = this.querySelector('.bestsellers__nav');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      if (!this.slider) return;

      this.slider.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevBtn?.addEventListener('click', this.onNavClick);
      this.nextBtn?.addEventListener('click', this.onNavClick);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.slider);

      this.updateProgress();
      this.updateButtons();
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.onScroll);
      this.prevBtn?.removeEventListener('click', this.onNavClick);
      this.nextBtn?.removeEventListener('click', this.onNavClick);
      this.resizeObserver?.disconnect();
    }

    onResize() {
      this.updateProgress();
      this.updateButtons();
    }

    onScroll() {
      this.updateProgress();
      this.updateButtons();
    }

    onNavClick(event) {
      const direction = event.currentTarget.dataset.direction;
      const slide = this.slider.querySelector('.bestsellers__slide');
      if (!slide) return;

      const slideWidth = slide.offsetWidth + parseInt(getComputedStyle(this.slider).gap, 10);
      const scrollAmount = direction === 'next' ? slideWidth : -slideWidth;

      this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    updateProgress() {
      if (!this.slider || !this.progressBar) return;

      const slides = this.slider.querySelectorAll('.bestsellers__slide');
      const totalSlides = slides.length;
      if (totalSlides === 0) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

      if (maxScroll <= 1) {
        this.progressBar.style.width = '100%';
        this.updateButtons();
        return;
      }

      const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(this.slider).gap, 10);
      const visibleCount = this.slider.clientWidth / slideWidth;
      const initialProgress = visibleCount / totalSlides;
      const scrollProgress = this.slider.scrollLeft / maxScroll;
      const progress = Math.min(initialProgress + scrollProgress * (1 - initialProgress), 1) * 100;

      this.progressBar.style.width = `${progress}%`;

      this.updateButtons();
    }

    updateButtons() {
      if (!this.slider) return;

      const scrollLeft = this.slider.scrollLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const isOverflowing = maxScroll > 1;

      this.classList.toggle('bestsellers--fits', !isOverflowing);

      if (!isOverflowing && scrollLeft > 0) {
        this.slider.scrollLeft = 0;
      }

      if (this.nav) this.nav.hidden = !isOverflowing;
      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1 || !isOverflowing;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1 || !isOverflowing;
    }
  }

  customElements.define('bestsellers-carousel', BestsellersCarousel);
})();
